import { reactive } from 'vue';
import { createStore } from 'vuex';

const getWindowSize = ()=>{
  const w = window.innerWidth;
  const h = window.innerHeight;
  const defaultSize = {
    video: {
      pc: {
        h: 700,
        w: 560,
        adjustH: 200,
        adjustW: 200,
      }, 
      sp: {
        h: 804,
        w: 642,
        adjustH: 140,
        adjustW: 52,
      }}
    };
  let videoSize;

  if (window.matchMedia('(max-width: 900px)').matches) {
    // sp
    videoSize = {
      h: defaultSize.video.sp.h,
      w: defaultSize.video.sp.w,
      adjustH: (defaultSize.video.sp.adjustH / 375) * w,
      adjustW: (defaultSize.video.sp.adjustW / 375) * w,
    };
  } else {
    // pc
    videoSize = defaultSize.video.pc;
  }

  return {
    w: w,
    h: h,
    videoSize: videoSize,
  }
}

export default createStore({
  state: {
    size: {},
    assetsPath: '/special/tenkyu/10color/assets/',

    currentPoloID: '',
    isFirstLoaded: false,
    isLowPowerMode: false,
    isLoadOpening: false,
    
    isShowLoad: true,
    isShowModal: false,
    isShowHead: false,
    isShowFoot: false,
    isShowScrolldown:false,

    isShowVideo: false,

    isBgInit: false,
    isBgTop1: false,
    isBgTop2: false,
    isBgPolo: false,

    isStartTop: false,
    isShowTop: false,

    isStartPolo: false,
    isShowPolo: false,
    
    loadTime: 1.0,
    lang: gPG.lang,
  },
  mutations: {
    update(state) {
      const size = getWindowSize();
      state.size = size;
    },
    // setChangePage(state, name) {
    //   state.changePage = name;
    // },

    setCurrentPoloID(state, polo) {
      state.currentPoloID = polo;
    },
    setFirstLoaded(state, isLoaded) {
      state.isFirstLoaded = isLoaded;
    },
    setLowPowerMode(state, isLowPower) {
      state.isLowPowerMode = isLowPower;
    },
    setLoadOpening(state, isLoaded) {
      state.isLoadOpening = isLoaded;
    },

    setShowLoad(state, isShow) {
      state.isShowLoad = isShow;
    },
    setShowModal(state, isShow) {
      state.isShowModal = isShow;
    },
    setShowHead(state, isShow) {
      state.isShowHead = isShow;
    },
    setShowFoot(state, isShow) {
      state.isShowFoot = isShow;
    },
    setShowScrolldown(state, isShow) {
      state.isShowScrolldown = isShow;
    },
    
    setShowVideo(state, isShow) {
      state.isShowVideo = isShow;
    },
    
    isBgInit(state, isShow) {
      state.isBgInit = isShow;
    },
    isBgTop1(state, isShow) {
      state.isBgTop1 = isShow;
    },
    isBgTop2(state, isShow) {
      state.isBgTop2 = isShow;
    },
    isBgPolo(state, isShow) {
      state.isBgPolo = isShow;
    },

    setStartTop(state, isStart) {
      state.isStartTop = isStart;
    },
    setShowTop(state, isShow) {
      state.isShowTop = isShow;
    },

    setStartPolo(state, isStart) {
      state.isStartPolo = isStart;
    },
    setShowPolo(state, isShow) {
      state.isShowPolo = isShow;
    },

    setLang(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
  },
  getters: {
    // containerH(state) {
    //   return state.itemContainerH;
    // },
    // getItemAll: (state) => {
    //   return state.items;
    // },
    size(state) {
      return state.size;
    },
    // changePage(state) {
    //   return state.changePage;
    // },
    assetsPath(state) {
      return state.assetsPath;
    },
    currentPoloID(state) {
      return state.currentPoloID;
    },
    isFirstLoaded: (state) => {
      return state.isFirstLoaded;
    },
    isLowPowerMode: (state) => {
      return state.isLowPowerMode;
    },
    isLoadOpening: (state) => {
      return state.isLoadOpening;
    },

    isShowLoad: (state) => {
      return state.isShowLoad;
    },
    isShowModal: (state) => {
      return state.isShowModal;
    },
    isShowHead: (state) => {
      return state.isShowHead;
    },
    isShowFoot: (state) => {
      return state.isShowFoot;
    },
    isShowScrolldown: (state) => {
      return state.isShowScrolldown;
    },

    isShowVideo: (state) => {
      return state.isShowVideo;
    },

    isBgInit: (state) => {
      return state.isBgInit;
    },
    isBgTop1: (state) => {
      return state.isBgTop1;
    },
    isBgTop2: (state) => {
      return state.isBgTop2;
    },
    isBgPolo: (state) => {
      return state.isBgPolo;
    },

    isStartTop: (state) => {
      return state.isStartTop;
    },
    isShowTop: (state) => {
      return state.isShowTop;
    },

    isStartPolo: (state) => {
      return state.isStartPolo;
    },
    isShowPolo: (state) => {
      return state.isShowPolo;
    },

    loadTime: (state) => {
      return state.loadTime;
    },
    lang: (state) => {
      return state.lang;
    },
  },
  modules: {
  }
});